'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { Field as PresetField, FieldDescription, FieldError, FieldLabel } from './ui/field';
export function Field({ label, hint, error, required = false, requiredMark = true, children, }) {
    const base = useId();
    const controlId = `${base}-control`;
    const hintId = `${base}-hint`;
    const errorId = `${base}-error`;
    const hasError = error !== undefined && error !== null && error !== false;
    const showHint = !hasError && hint !== undefined;
    const describedBy = hasError ? errorId : showHint ? hintId : undefined;
    return (_jsxs(PresetField, { "data-invalid": hasError || undefined, children: [_jsxs(FieldLabel, { htmlFor: controlId, children: [label, required && requiredMark ? _jsx("span", { "aria-hidden": "true", children: "*" }) : null] }), children({
                id: controlId,
                'aria-describedby': describedBy,
                'aria-invalid': hasError || undefined,
                required: required || undefined,
            }), showHint ? _jsx(FieldDescription, { id: hintId, children: hint }) : null, hasError ? (_jsx(FieldError, { id: errorId, role: "alert", children: error })) : null] }));
}
//# sourceMappingURL=Field.js.map